// This function allow to reference all chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + {"2888":"88c718d252da622c","4057":"f0fccade621eb57e","6964":"98c144e8f1011c5d"}[chunkId] + ".css";
};